import React from 'react';
import PropTypes from 'prop-types';

import { LayoutBlock } from 'components/Layout';
import Container from 'components/Container';
import MainPromoBlocks from 'components/promoBlocks/MainPromoBlocks';

const SectionMainPromoBlock = ({ blocks }) => (
	<LayoutBlock>
		<Container>
			<MainPromoBlocks blocks={blocks} />
		</Container>
	</LayoutBlock>
);

SectionMainPromoBlock.propTypes = {
	blocks: PropTypes.array
};

export default SectionMainPromoBlock;
